import { ChevronDown, ChevronUp } from "lucide-react";
import React, { useState } from "react";
import Footer from "../Components/Footer";
import Navbar from "../Components/Header";
import blobTopLeft from "../Images/tealback.png";
const categories = [
  {
    category: "Designing",
    questions: [
      "What types of graphic design services do you offer?",
      "Can you help with both digital and print design?",
      "What information do you need from me to start a design project?",
      "Do you offer design packages or custom quotes?",
      "How many revisions are included in your design services?",
      "Do you offer design services for marketing materials like brochures or flyers?",
      "How do you handle copyright and ownership of designs?",
      "Can you provide design services for merchandise and promotional items?",
      "What is your process for handling urgent design requests?",
      "Can you work with existing branding materials?",
    ],
    answers: [
      "We offer a variety of services including logos, banners, flyers, business cards, social media posts, packaging design, motion graphics, and more. Contact us for further details.",
      "Yes, we provide design solutions for both digital platforms and print materials.",
      "We need details about your project goals, target audience, brand guidelines, and any specific design preferences or requirements.",
      "We offer both design packages and custom quotes based on your specific needs and project scope.",
      "The number of revisions included will be specified in the project agreement. We aim to ensure that you’re satisfied with the final design.",
      "Yes, we design various marketing materials, including brochures, flyers, and other promotional assets.",
      "Once a project is completed and paid for, you will own the rights to the design. We also provide necessary files and documents for your records.",
      "Yes, we design assets for various merchandise and promotional items, including T-shirts, mugs, and other branded products.",
      "We prioritize urgent requests based on availability and will provide a timeline for completion. Additional charges may apply for expedited services.",
      "Yes, we can work with your existing branding materials to create cohesive and complementary designs.",
    ],
  },
  {
    category: "Marketing",
    questions: [
      "What does your social media strategy development include?",
      "How do you create engaging content for social media?",
      "How do you handle paid social media advertising?",
      "Can you manage influencer marketing campaigns?",
      "How do you measure the success of a social media campaign?",
      "Do you offer social media community management?",
      "How do you determine the best social media platforms for my business?",
      "What is your approach to creating a content calendar?",
      "How do you handle social media crises or negative comments?",
      "What tools do you use for social media management and analytics?",
    ],
    answers: [
      "Our strategy includes audience analysis, competitor analysis, platform selection, content planning, and campaign execution.",
      "We create content that resonates with your audience through storytelling, eye-catching visuals, and relevant messaging.",
      "We manage ad campaigns, including targeting, budget optimization, A/B testing, and retargeting to maximize ad performance.",
      "Yes, we identify influencers, coordinate campaigns, and track performance to ensure successful collaborations.",
      "We measure success using key metrics such as engagement, reach, conversions, and ROI, and provide detailed performance reports.",
      "Yes, we handle community management including engagement, social listening, and crisis management to maintain a positive online presence.",
      "We analyze your target audience, industry trends, and business goals to recommend the most effective platforms for your social media marketing.",
      "We develop a content calendar that aligns with your marketing goals, includes key dates and events, and ensures a consistent posting schedule.",
      "We have strategies in place for crisis management and handle negative comments professionally to protect your brand’s reputation.",
      "We use various tools for social media management and analytics, including Hootsuite, Buffer, Google Analytics, and platform-specific insights.",
    ],
  },
  {
    category: "Social Media Management",
    questions: [
      "What is involved in profile setup and optimization?",
      "How do you manage content scheduling and posting?",
      "What strategies do you use for audience engagement?",
      "How do you handle reputation management on social media?",
      "What is included in your social media analytics?",
      "Can you manage multiple social media accounts?",
      "Do you offer competitor monitoring services?",
      "How do you handle social media analytics and reporting?",
      "What strategies do you use for growing my social media following?",
      "How do you handle scheduling and posting for international audiences?",
    ],
    answers: [
      "We handle account creation, profile branding, and custom graphics to ensure your profiles are professionally set up.",
      "We create a content calendar, schedule posts for optimal times, and adapt content for each social media platform.",
      "We monitor interactions, respond to comments and messages, and foster relationships with followers to boost engagement.",
      "We monitor brand mentions, address negative feedback, and implement strategies to maintain a positive reputation.",
      "We provide performance reports, content analysis, audience insights, and recommendations for improving social media strategies.",
      "Yes, we can manage multiple accounts across various platforms, ensuring consistent and effective communication.",
      "Yes, we analyze competitors’ activities and strategies to provide insights and help you stay ahead in your market.",
      "We track key metrics, analyze performance data, and provide detailed reports with insights and recommendations for improvement.",
      "We use strategies such as targeted content, engagement tactics, and promotions to organically grow your social media following.",
      "We adjust scheduling to accommodate different time zones and ensure content reaches your international audience at optimal times.",
    ],
  },
  {
    category: "SEO",
    questions: [
      "What does on-page SEO include?",
      "How do you approach keyword research?",
      "What is technical SEO and why is it important?",
      "How do you handle off-page SEO?",
      "What kind of SEO reporting do you provide?",
      "Can you help with local SEO?",
      "Do you offer SEO audits?",
      "What are the key components of a successful SEO strategy?",
      "What is your approach to building backlinks?",
      "How do you measure the impact of SEO efforts?",
    ],
    answers: [
      "On-page SEO involves optimizing website elements like meta tags, keywords, content, and internal linking for better search engine rankings.",
      "We conduct comprehensive keyword research to identify relevant terms and phrases that will drive traffic to your site.",
      "Technical SEO focuses on site speed, mobile-friendliness, and other backend factors that affect search engine rankings and user experience.",
      "We implement link building strategies, guest blogging, and local SEO tactics to boost your site’s authority and visibility.",
      "We provide detailed reports on rankings, traffic, and other key metrics, along with recommendations for ongoing optimization.",
      "Yes, we optimize your site for local search results, including managing Google My Business and local directory listings.",
      "Yes, we conduct comprehensive SEO audits to identify issues and opportunities for improving your website’s search engine performance.",
      "Key components include keyword research, on-page optimization, high-quality content, technical SEO, and effective link building.",
      "We focus on acquiring high-quality backlinks through guest blogging, partnerships, and outreach to enhance your site’s authority.",
      "We measure impact using metrics such as organic traffic, keyword rankings, conversion rates, and overall ROI.",
    ],
  },
  {
    category: "Video Editing",
    questions: [
      "Do you provide custom animations and motion graphics?",
      "How do you handle video color grading and manipulation?",
      "What is included in your video editing services?",
      "How do you ensure video content meets my brand’s style?",
      "Can you add voiceovers or sound effects to videos?",
      "Do you offer revisions for video projects?",
      "Can you work with footage from various sources?",
      "What is your process for adding subtitles to videos?",
      "How do you handle video content that needs to be adapted for different platforms?",
      "What tools and software do you use for video editing?",
    ],
    answers: [
      "Yes, we create custom animations, motion graphics, and visual effects to enhance your videos.",
      "We use advanced color grading techniques to enhance video aesthetics and ensure visual consistency.",
      "Our services include seamless transitions, subtitles, sound design, and other elements to create polished and professional videos.",
      "We collaborate closely with you to understand your brand’s style and incorporate it into the video content.",
      "Yes, we offer voiceover services and sound effects to enhance the overall impact of your video content.",
      "Yes, we offer revisions to ensure the final video meets your expectations. The number of revisions will be specified in the project agreement.",
      "Yes, we can edit footage from different sources, including raw video files, mobile recordings, and existing content.",
      "We transcribe audio, synchronize subtitles with video, and ensure accuracy and readability for an enhanced viewer experience.",
      "We tailor video content to fit the requirements and best practices of different platforms, including format, length, and aspect ratio adjustments.",
      "We use industry-standard tools and software such as Adobe Premiere Pro, After Effects, Final Cut Pro, and others for high-quality video editing.",
    ],
  },
  {
    category: "Web Development",
    questions: [
      "What types of websites do you develop?",
      "Can you handle eCommerce website development?",
      "What is included in your custom web application development?",
      "Do you offer website maintenance and updates?",
      "How do you ensure my website is mobile-friendly?",
      "What is the process for developing a new website?",
      "Can you help with website redesigns?",
      "What is your approach to website security?",
      "What is the difference between static and dynamic websites?",
      "Can you develop custom features for my website?",
      "How do you ensure website performance and speed?",
      "What is included in website usability testing?",
      "Can you integrate third-party",
      "Do you offer website hosting and domain registration services?",
    ],
    answers: [
      "We develop static websites, custom web applications, and advanced web applications with various features and functionalities.",
      "Yes, we develop eCommerce websites with features such as product listings, shopping carts, and secure payment gateways.",
      "Custom development includes backend logic, API integration, and any specific features or functionalities you require.",
      "Yes, we provide ongoing maintenance and updates to ensure your website remains functional and up to date.",
      "We design and develop websites with responsive layouts to ensure they work well on all devices, including mobile phones and tablets.",
      "Our process includes planning, design, development, testing, and deployment, followed by ongoing support.",
      "Yes, we can redesign existing websites to improve functionality, aesthetics, and user experience.",
      "We implement security best practices, including regular updates, secure coding practices, and monitoring to protect your website from threats.",
      "Static websites have fixed content that doesn’t change unless manually updated, while dynamic websites have content that can change based on user interactions or other inputs.",
      "Yes, we can develop custom features tailored to your business needs, including interactive elements, custom forms, and advanced functionalities.",
      "We optimize website performance through techniques such as caching, image optimization, and efficient coding practices.",
      "Usability testing includes assessing the site’s ease of use, navigation, accessibility, and overall user experience to ensure it meets user needs.",
      "Yes, we can integrate various third-party tools and services, including CRM systems, payment gateways, and marketing automation platforms.",

      "Yes, we can assist with website hosting and domain registration, ensuring a seamless setup and management process.",
    ],
  },
];

const FAQPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("Designing");
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setOpenIndex(null); // Close all FAQs when switching categories
  };

  return (
    <>
      <div className="">
        <Navbar color={"bg-white text-teal-950"} />
      </div>
      <div
        className="relative pt-20 bg-teal-500 text-white min-h-screen flex flex-col items-center justify-center px-6"
        style={{
          backgroundImage: `url(${blobTopLeft})`,
          backgroundSize: "cover",
          backgroundPosition: "top left",
          backgroundRepeat: "no-repeat",
          backgroundAttachment: "fixed", // Fix background movement
        }}
      >
        <h1 className="text-3xl lg:text-4xl font-semibold mb-12 text-center">
          Got Questions? We've Got Answers
        </h1>

        {/* Category Buttons */}
        <div className="mb-8 flex flex-wrap justify-center md:justify-start lg:justify-start space-x-4">
          {categories.map((cat, index) => (
            <button
              key={index}
              onClick={() => handleCategorySelect(cat.category)}
              className={`px-4 py-2 my-2 rounded-lg transition-all duration-300 ${
                selectedCategory === cat.category
                  ? "bg-teal-100 text-teal-600 font-medium"
                  : "bg-teal-200 bg-opacity-50 text-white font-medium"
              }`}
            >
              {cat.category}
            </button>
          ))}
        </div>

        {/* FAQ Section */}
        <div className="w-full max-w-4xl">
          {categories
            .filter((cat) => cat.category === selectedCategory)
            .map((faq, i) => (
              <div key={i} className="mb-8">
                <h2 className="text-xl font-bold mb-4">{faq.category}:</h2>
                {faq.questions.map((question, index) => (
                  <div key={index}>
                    <button
                      onClick={() => toggleFAQ(index)}
                      className="w-full text-left py-4 md:py-5 lg:py-5 border-b border-teal-50 hover:bg-gray-300 hover:bg-opacity-15 focus:outline-none"
                    >
                      {question}
                      <span className="float-right">
                        {openIndex === index ? <ChevronUp /> : <ChevronDown />}
                      </span>
                    </button>
                    <div
                      className={`transition-all overflow-hidden duration-500 ${
                        openIndex === index ? "max-h-96" : "max-h-0"
                      }`}
                    >
                      <div className="text-lg  p-4 bg-teal-500 bg-opacity-50">
                        <p>{faq.answers[index]}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ))}

          <div className="flex flex-col items-center justify-center text-center mt-5 md:mt-10 lg:mt-20 py-6 border-white bg-white  border mb-20 rounded-lg">
            {/* Introductory Text */}
            <h2 className="text-2xl font-bold text-teal-500 mb-4">
              Get in Touch
            </h2>
            <p className="font-normal text-gray-500 mb-6 text-sm px-10">
              We would love to hear from you! Whether you have a question,
              feedback, or just want to chat, feel free to reach out to us. Our
              team is here to assist you.
            </p>

            {/* Contact Us Button */}
            <button class="px-5 z-30 py-3 bg-teal-500 bg-opacity-70 border-teal-50 border rounded-md text-white relative font-medium after:-z-20 hover:text-white after:absolute after:h-1 after:w-1 after:bg-teal-300 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700  text-lg">
              <a href="/contact" className="">
                Contact Us
              </a>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default FAQPage;
